export default __webpack_public_path__ + "static/media/Orange Juice -  proportioned_170.d84f8bca.jpg";